import React, { useContext } from "react";
import { ReferralLinksStatistics } from "features/affiliation/common/types";
import ReferralLinksTable from "features/affiliation/ReferralLinks/ReferralLinksTable";
import CardsAndTableLayout from "features/affiliation/common/CardsAndTableLayout";
import useReferralLinks from "features/affiliation/common/hooks/useReferralLinks";
import StatisticsRow from "features/affiliation/common/StatisticsRow";
import { AffiliationContext } from "features/affiliation/Affiliation.context";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

import { LanguageNameSpaces } from "@shared/types";

const ReferralLinks = () => {
  const { t } = useTypedTranslation(LanguageNameSpaces.AFFILIATION);
  const { hasFeatureFlag } = useContext(AffiliationContext)!;
  const { referralLinksQuery, getStatisticValue, referralLinksTabStatistics } =
    useReferralLinks();

  const referralLinksTable = hasFeatureFlag ? (
    <ReferralLinksTable
      referralLinks={referralLinksQuery.data}
      isLoading={referralLinksQuery.isFetching}
    />
  ) : undefined;

  const referralLinksStatistics = (
    <StatisticsRow<ReferralLinksStatistics>
      statisticsTitles={referralLinksTabStatistics}
      getStatisticValue={getStatisticValue}
    />
  );

  return (
    <CardsAndTableLayout
      loading={referralLinksQuery.isLoading}
      tableTitle={t("links.title")}
      table={referralLinksTable}
      statistics={referralLinksStatistics}
    />
  );
};

export default ReferralLinks;
